<dcp-new-form-field-select-autocomplete
  [autoSelectLstIdTag]="'RecipesModifyStepsUtensilLst'"
  [autoSelectBtnIdTag]="'RecipesModifyStepsUtensilBtn'"
  class="form-field-xl"
  [allChoices]="(allChoices$ | async) || []"
  [selectedChoices]="(selectedChoices$ | async) || []"
  (selectedChoicesChange)="updateChosenUtensilsInForm($event)"
>
</dcp-new-form-field-select-autocomplete>
